import { render, staticRenderFns } from "./AttachmentPreviewButton.vue?vue&type=template&id=20f4fee0&scoped=true"
import script from "./AttachmentPreviewButton.vue?vue&type=script&lang=js"
export * from "./AttachmentPreviewButton.vue?vue&type=script&lang=js"
import style0 from "./AttachmentPreviewButton.vue?vue&type=style&index=0&id=20f4fee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f4fee0",
  null
  
)

export default component.exports